const TipoTarefaPedidoEnum={

    APROVACAO_ALMOXARIFADO:10,
    APROVACAO_SOLICITANTE:11,
    RETIRADA:12,
    RECEBIMENTO:13,

}

export default TipoTarefaPedidoEnum;